import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  signOut,
  type User,
} from 'firebase/auth';

/**
 * Google sign-in, as today. The ID token goes out as `Authorization: Bearer` on every
 * call — the `?t=<token>` query-param hack is gone along with the directly-navigated
 * protected HTML pages it existed for.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyAXJUdeRbYgXsT3D8nQh9OgjQuVhtE3GCg',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'ublfirebase.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'ublfirebase',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'ublfirebase.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID ?? '758741998164',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:758741998164:web:850a62efa2dc144c46ebc1',
};

/**
 * With `VITE_DEV_AUTH_EMAIL` set, the app skips Firebase and sends that address as the
 * bearer token, matching the server's `DEV_AUTH_BYPASS`. Local development only.
 */
export const devEmail: string | undefined = import.meta.env.VITE_DEV_AUTH_EMAIL;

const app = devEmail ? undefined : initializeApp(firebaseConfig);
const auth = app ? getAuth(app) : undefined;

export function watchAuth(cb: (user: User | null) => void): () => void {
  if (!auth) {
    cb(null);
    return () => {};
  }
  return onAuthStateChanged(auth, cb);
}

export async function signIn(): Promise<void> {
  if (!auth) return;
  await signInWithPopup(auth, new GoogleAuthProvider());
}

export async function signOutNow(): Promise<void> {
  if (!auth) return;
  await signOut(auth);
}

/** The current bearer token, refreshed by the SDK as needed. */
export async function idToken(): Promise<string | undefined> {
  if (devEmail) return devEmail;
  return auth?.currentUser ? auth.currentUser.getIdToken() : undefined;
}

export type { User };
